// @ts-nocheck
(function () {
  "use strict";

  const root = document.querySelector("[data-shopping-history-root]");
  if (!root) return;

  function hideLoader() {
    root.classList.remove("is-loading");
  }

  const listEl = root.querySelector("[data-shopping-history-list]");
  const emptyEl = root.querySelector("[data-shopping-history-empty]");
  const typeGroup = root.querySelector('[data-filter-group="type"]');
  const yearGroup = root.querySelector('[data-filter-group="year"]');

  if (!listEl) {
    hideLoader();
    return;
  }

  if (!window.AccountAuth || !window.AccountHttp || !window.AccountEndpoints) {
    console.error(
      "[shopping-history] AccountAuth/AccountHttp/AccountEndpoints not loaded — check script order.",
    );
    hideLoader();
    return;
  }

  const { authFetch } = window.AccountHttp;
  const { TRANSACTIONS } = window.AccountEndpoints;

  const RECEIPT_PAGE_URL =
    root.getAttribute("data-receipt-url") || "/pages/shopping-receipt";

  const PLACEHOLDER_IMAGE = root.getAttribute("data-placeholder-image");

  const PAGE_SIZE = 24;

  const state = {
    type: "all",
    year: "all",
    transactions: [],
    offset: 0,
    total: null,
    loading: false,
  };

  let loadMoreBtn = null;

  // ---- helpers ---------------------------------------------------------

  function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function formatDate(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return (
      ordinal(d.getDate()) +
      " " +
      d.toLocaleString("en-GB", { month: "long" }) +
      " " +
      d.getFullYear()
    );
  }

  function formatYear(iso) {
    const d = new Date(iso);
    return isNaN(d.getTime()) ? "" : String(d.getFullYear());
  }

  function formatMoney(amount, currency) {
    if (amount === null || amount === undefined) return "";
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency || "GBP",
        signDisplay: "auto", // keeps the minus sign for refunds intact
      }).format(amount);
    } catch (err) {
      const sign = amount < 0 ? "-" : "";
      return sign + (currency || "£") + Math.abs(Number(amount)).toFixed(2);
    }
  }

  function firstProductImage(products) {
    if (!Array.isArray(products)) return null;
    for (let i = 0; i < products.length; i++) {
      const urls = products[i] && products[i].imageUrls;
      if (Array.isArray(urls)) {
        const found = urls.find(function (u) {
          return u && u.trim();
        });
        if (found) return found;
      }
    }
    return null;
  }

  function mapTransaction(raw) {
    const summary = raw.basketSummary || {};
    const isOnline = !!(summary.webOrder && summary.webOrder.totalItems > 0);
    const isRefund = raw.type === "REFUND";
    const total =
      summary.shippingTotal > 0
        ? summary.basketTotalWithShippingTotal
        : summary.basketTotal;
    const dateIso = raw.dateTime || raw.createdAt;

    return {
      id: raw.id,
      orderType: isOnline ? "online" : "in_store",
      isRefund: isRefund,
      dateLabel: formatDate(dateIso),
      year: formatYear(dateIso),
      priceLabel: formatMoney(total, raw.baseCurrency),
      itemsCount: summary.totalItems,
      imageUrl: firstProductImage(raw.basket && raw.basket.products),
    };
  }

  // ---- rendering ---------------------------------------------------------

  function ensureYearPill(year) {
    if (!yearGroup || !year) return;
    if (yearGroup.querySelector('[data-filter-value="' + year + '"]')) return;

    const sep = document.createElement("span");
    sep.className = "filter-sep";
    sep.setAttribute("aria-hidden", "true");
    sep.textContent = "|";

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "filter-pill";
    btn.setAttribute("data-filter-value", year);
    btn.setAttribute("role", "tab");
    btn.setAttribute("aria-selected", "false");
    btn.textContent = year;

    yearGroup.appendChild(sep);
    yearGroup.appendChild(btn);
  }

  function buildCard(tx) {
    const card = document.createElement("div");
    card.className = "purchase-card";
    card.setAttribute("data-purchase-type", tx.orderType);
    card.setAttribute("data-purchase-year", tx.year);
    if (tx.isRefund) card.setAttribute("data-purchase-refund", "true");

    const imageWrap = document.createElement("div");
    imageWrap.className = "purchase-card-image";

    // Badge: refund takes priority over the online badge if both apply,
    // since "this is a refund" is the more important signal to the customer.
    if (tx.isRefund) {
      const badge = document.createElement("span");
      badge.className = "purchase-card-badge";
      badge.textContent = "Refund";
      imageWrap.appendChild(badge);
    } else if (tx.orderType === "online") {
      const badge = document.createElement("span");
      badge.className = "purchase-card-badge";
      badge.textContent = "Online order";
      imageWrap.appendChild(badge);
    }

    function appendPlaceholder() {
      if (!PLACEHOLDER_IMAGE) {
        const placeholder = document.createElement("div");
        placeholder.className = "purchase-card-image-placeholder";
        imageWrap.appendChild(placeholder);
        return;
      }
      const ph = document.createElement("img");
      ph.src = PLACEHOLDER_IMAGE;
      ph.loading = "lazy";
      ph.alt = "Product image unavailable";
      ph.className = "purchase-card-image-placeholder";
      imageWrap.appendChild(ph);
    }

    if (tx.imageUrl) {
      const img = document.createElement("img");
      img.src = tx.imageUrl;
      img.loading = "lazy";
      img.alt = tx.dateLabel;
      img.addEventListener("error", function () {
        img.remove();
        appendPlaceholder();
      });
      imageWrap.appendChild(img);
    } else {
      appendPlaceholder();
    }

    const date = document.createElement("p");
    date.className = "purchase-card-date";
    date.textContent = tx.dateLabel;

    const price = document.createElement("p");
    price.className = "purchase-card-price";
    price.textContent = tx.priceLabel;

    const items = document.createElement("p");
    items.className = "purchase-card-items";
    items.textContent =
      tx.itemsCount != null
        ? tx.itemsCount + (tx.itemsCount === 1 ? " item" : " items")
        : "";

    const link = document.createElement("a");
    link.className =
      "purchase-card-link link-hover-line link-hover-line--primary";
    link.href = RECEIPT_PAGE_URL + "?id=" + encodeURIComponent(tx.id);
    link.textContent =
      tx.orderType === "online" ? "Order details" : "View receipt";

    card.appendChild(imageWrap);
    card.appendChild(date);
    card.appendChild(price);
    card.appendChild(items);
    card.appendChild(link);

    return card;
  }

  function applyFilters() {
    const cards = Array.prototype.slice.call(
      listEl.querySelectorAll(".purchase-card"),
    );
    let visibleCount = 0;
    cards.forEach(function (card) {
      const matchesType =
        state.type === "all" ||
        card.getAttribute("data-purchase-type") === state.type;
      const matchesYear =
        state.year === "all" ||
        card.getAttribute("data-purchase-year") === state.year;
      const visible = matchesType && matchesYear;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    if (emptyEl) emptyEl.hidden = visibleCount > 0;
  }

  function setActivePill(group, value) {
    if (!group) return;
    const pills = group.querySelectorAll(".filter-pill");
    pills.forEach(function (pill) {
      const isActive = pill.getAttribute("data-filter-value") === value;
      pill.classList.toggle("is-active", isActive);
      pill.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  function bindFilterGroup(group, key) {
    if (!group) return;
    group.addEventListener("click", function (event) {
      const pill = event.target.closest(".filter-pill");
      if (!pill || !group.contains(pill)) return;
      const value = pill.getAttribute("data-filter-value");
      state[key] = value;
      setActivePill(group, value);
      applyFilters();
    });
  }

  function renderTransactions(list, reset) {
    if (reset) listEl.innerHTML = "";
    list.forEach(function (tx) {
      ensureYearPill(tx.year);
      listEl.appendChild(buildCard(tx));
    });
    applyFilters();
  }

  function renderLoadMore() {
    if (state.total === null || state.transactions.length >= state.total) {
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      return;
    }
    if (!loadMoreBtn) {
      loadMoreBtn = document.createElement("button");
      loadMoreBtn.type = "button";
      loadMoreBtn.className = "filter-pill";
      loadMoreBtn.style.marginTop = "32px";
      loadMoreBtn.textContent = "Load more";
      loadMoreBtn.addEventListener("click", loadPage);
      const inner = root.querySelector(".account-inner");
      if (inner) inner.appendChild(loadMoreBtn);
    }
    loadMoreBtn.hidden = false;
  }

  // ---- data loading ---------------------------------------------------------

  function loadPage() {
    if (state.loading) return;
    state.loading = true;
    const isFirstPage = state.offset === 0;

    if (loadMoreBtn) {
      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = "Loading…";
    }

    const url =
      TRANSACTIONS + "?limit=" + PAGE_SIZE + "&offset=" + state.offset;

    authFetch(url, { method: "GET" })
      .then(function (res) {
        if (!res.ok || !res.data) {
          console.error(
            "[shopping-history] Transactions API responded with",
            res.status,
          );
          if (isFirstPage && emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent =
              "We couldn't load your purchase history right now. Please try again later.";
          }
          return;
        }

        const body = res.data;
        const items = Array.isArray(body.result) ? body.result : [];
        const total =
          typeof body.totalCount === "number" ? body.totalCount : items.length;
        const mapped = items.map(mapTransaction);

        state.transactions = state.transactions.concat(mapped);
        state.total = total;
        state.offset += items.length;

        renderTransactions(mapped, isFirstPage);
        renderLoadMore();
      })
      .catch(function (err) {
        console.error("[shopping-history] Failed to fetch transactions:", err);
        if (isFirstPage && emptyEl) {
          emptyEl.hidden = false;
          emptyEl.textContent =
            "We couldn't load your purchase history right now. Please try again later.";
        }
      })
      .finally(function () {
        state.loading = false;
        hideLoader();
        if (loadMoreBtn) {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = "Load more";
        }
      });
  }

  bindFilterGroup(typeGroup, "type");
  bindFilterGroup(yearGroup, "year");

  loadPage();
})();
